import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import BaseDrawer from "../../UI/BaseDrawer/BaseDrawer";
import { TermsAndConditionsAPI } from "../../../util/API/admin";

function TermsAndConditions({ open, handleCloseModal }) {
  const [tandc, setTAndC] = useState("");

  const getTermsAndConditions = async () => {
    const response = await TermsAndConditionsAPI();
    setTAndC(response?.payload || "");
    console.log(response);
  };

  useEffect(() => {
    if (open) {
      getTermsAndConditions();
    }
  }, [open]);

  // Helper to parse and display Terms and Conditions
  const renderTermsAndConditions = (text) => {
    // Split by {{P}} and {{/P}} to extract paragraphs
    const paragraphs = text.split(/{{P}}|{{\/P}}/).filter((p) => p.trim() !== "");

    return paragraphs.map((paragraph, index) => (
      <Box key={index} sx={{ mb: 3 }}>
        <Typography variant="body1" sx={{ fontFamily: "Nunito", color: "#333", mb: 3 }}>
          {paragraph}
        </Typography>
      </Box>
    ));
  };

  return (
    <BaseDrawer open={open} handleClose={handleCloseModal} height="80vh" title="Terms and Conditions">
      <Box sx={{ p: 3, overflowY: "auto", maxHeight: "100%" }}>
        {tandc ? (
          renderTermsAndConditions(tandc)
        ) : (
          <Typography variant="body2" sx={{ color: "#888" }}>
            Loading Terms and Conditions...
          </Typography>
        )}
      </Box>
    </BaseDrawer>
  );
}

export default TermsAndConditions;
